import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import "../style/delete-modal.css";

export default function LogoutConfirmModal({ isOpen, onClose, onConfirm }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    if (isOpen) {
      window.addEventListener("keydown", handleKeyDown);
      return () => window.removeEventListener("keydown", handleKeyDown);
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="delete-modal-overlay" onClick={onClose}>
      <div className="delete-modal-card" onClick={(e) => e.stopPropagation()}>
        <h2 className="delete-modal-title">Log out?</h2>
        
        <p className="delete-modal-desc">
          Are you sure you want to log out of your account? You will need to sign in again to access your saved chats and history.
        </p>

        <div className="delete-modal-actions">
          <button
            type="button"
            className="delete-modal-cancel-btn"
            onClick={onClose}
          >
            Cancel
          </button>
          
          <button
            type="button"
            className="delete-modal-confirm-btn"
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            Logout
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
